"use strict";

var _defineProperty = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectAllocationInfo = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:abi-data:allocate:utils");

var Compilations = __importStar(require("../../compilations"));

var compile_common_1 = require("@truffle/compile-common");

var Contexts = __importStar(require("../../contexts"));

var Abi = __importStar(require("@truffle/abi-utils"));

function collectAllocationInfo(compilations) {
  var contexts = {};
  var deployedContexts = {};
  var contractsAndContexts = [];

  var _iterator = _createForOfIteratorHelper(compilations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var compilation = _step.value;

      var _iterator2 = _createForOfIteratorHelper(compilation.contracts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var contract = _step2.value;
          var node = Compilations.Utils.getContractNode(contract, compilation);
          var deployedContext = undefined;
          var constructorContext = undefined;
          var deployedBytecode = compile_common_1.Shims.NewToLegacy.forBytecode(contract.deployedBytecode);
          var bytecode = compile_common_1.Shims.NewToLegacy.forBytecode(contract.bytecode);

          if (deployedBytecode && deployedBytecode !== "0x") {
            deployedContext = Contexts.Utils.makeContext(contract, node, compilation);
            contexts[deployedContext.context] = deployedContext; //note that we don't set up deployedContexts until after normalization!
          }

          if (bytecode && bytecode !== "0x") {
            constructorContext = Contexts.Utils.makeContext(contract, node, compilation, true);
            contexts[constructorContext.context] = constructorContext;
          }

          contractsAndContexts.push({
            contract: contract,
            node: node,
            deployedContext: deployedContext,
            constructorContext: constructorContext,
            compilationId: compilation.id
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  debug("known contexts: %o", Object.keys(contexts));
  contexts = Contexts.Utils.normalizeContexts(contexts);
  deployedContexts = Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.values(contexts).map(function (context) {
    return !context.isConstructor ? _defineProperty({}, context.context, context) : {};
  }))));

  for (var _i = 0, _contractsAndContexts = contractsAndContexts; _i < _contractsAndContexts.length; _i++) {
    var contractAndContexts = _contractsAndContexts[_i];

    //change everything to normalized version
    if (contractAndContexts.deployedContext) {
      contractAndContexts.deployedContext = contexts[contractAndContexts.deployedContext.context]; //get normalized version
    }

    if (contractAndContexts.constructorContext) {
      contractAndContexts.constructorContext = contexts[contractAndContexts.constructorContext.context]; //get normalized version
    }
  }

  var allocationInfo = contractsAndContexts.map(function (_ref2) {
    var _ref2$contract = _ref2.contract,
        abi = _ref2$contract.abi,
        compiler = _ref2$contract.compiler,
        immutableReferences = _ref2$contract.immutableReferences,
        compilationId = _ref2.compilationId,
        node = _ref2.node,
        deployedContext = _ref2.deployedContext,
        constructorContext = _ref2.constructorContext;
    return {
      abi: Abi.normalize(abi),
      compilationId: compilationId,
      compiler: compiler,
      contractNode: node,
      deployedContext: deployedContext,
      constructorContext: constructorContext,
      immutableReferences: immutableReferences
    };
  });
  return {
    contexts: contexts,
    deployedContexts: deployedContexts,
    contractsAndContexts: contractsAndContexts,
    allocationInfo: allocationInfo
  };
}

exports.collectAllocationInfo = collectAllocationInfo;